/**
 * @function jitter
 * @description Shake the deck (disposition)
 * @param {number} m
 * @param {number} n
 * @returns
 */
export default function jitter(m, n) {
    var output = [];
    var maze_size = m * n * 3;
    for (var i = 1; i < m; i++) {
        for (var j = 1; j < n; j++) {
            output.push([
                i * maze_size + Math.floor(Math.random() * (maze_size / 2)),
                j * maze_size + Math.floor(Math.random() * (maze_size / 2)),
            ]);
        }
    }
    return output;
}
